<template>
	<v-container grid-list-xl>
		<v-form>
			<v-layout row wrap>
				<v-flex lg12>
					<p>Maximum file size allowed: {{ objAuthorize.max_upload_size }}MB<br />File types supported: {{ objAuthorize.allowed_file_types }}</p>
					<input type="file" id="quoteFile" class="fileUpload" @change="fncSetImageObj">
					<div class="fileHolder">
						<p>Drag & Drop / Click to Add Files</p>
						<small>{{ fileName }}</small>
					</div>
					<br />
					<small class="pt-4 pb-4" v-if="fncCheckFile() == false">No stock availability file has been uploaded</small>
					<v-data-table :headers="headers" :items="stockTable" v-if="fncCheckFile() == true" class="elevation-1 stockTable" hide-actions>
						<template slot="items" slot-scope="props">
							<td width="90%" class="text-xs-right"><a @click.prevent="fncOpenFile(stockAvailability)">View File</a></td>
							<td width="10%" class="text-xs-right"><a @click.prevent="fncRemoveStock()"><i class="material-icons">delete</i></a></td>
						</template>
					</v-data-table>
				</v-flex>
				<div class="pl-4 pr-4 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
					</div>
				</div>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import DatePicker from 'vue2-datepicker'

	export default {
		name: 'Settings',
		data() {
			return {
				fileName: '',
				headers: [
					{ text: 'File Name', value: 'name', width: '90%' },
					{ text: 'Delete', value: 'delete', width: '10%' }
				],
				stockTable: []
			};
		},
		methods: {
			fncCheckFile() {
				if( this.stockAvailability != null && this.stockAvailability.length > 0 && this.stockAvailability != '0' ) {
					return true;
				} else {
					return false;
				}
			},
			fncOpenFile(fileUrl) {
				window.open(fileUrl, '_blank');
			},
			fncHideModal() {
				this.$store.commit('fncEmptyStock');
				this.$store.commit('hideModal');
			},
			fncChangeUserType() {
				var companyType = this.userType == 2 ? 1 : 2;
				this.$store.dispatch({
					type: 'fncResetSetupUserCreate',
					companyType: companyType,
					userType: this.userType
				});
			},
			fncUpdateQuoteSettings() {
				this.$store.dispatch('fncUpdateQuoteSettings')
			},
			fncRemoveStock(key) {
				var doDelete = confirm('Are you sure you want to delete the stock availability file');
				if (doDelete == true) {
					this.$store.dispatch({
						type: 'fncRemoveStock'
					})
				}
			},
			fncSetImageObj(e) {
				var files = e.target.files[0] || e.dataTransfer.files[0];
				//var fivemeg = 5 * 1000000;
        if( this.maxFileSize != '' || this.maxFileSize != 0 ) {
          var fivemeg = parseInt(this.maxFileSize) * 1000000;
        } else {
          var fivemeg = 5 * 1000000;
        }
				if (parseInt(files.size) > fivemeg) {
					var snackDetails = { color: 'error', message: 'Please upload a file smaller than 5MB', display: true };
					this.$store.commit('setSnack', snackDetails);
				} else {
					var vm = this;
          var fileObj = String(files.name).split('.');
          var fileType = '.'+fileObj[fileObj.length-1];
          fileType = fileType.toLowerCase();
          if ( this.allowedFileTypes.indexOf( fileType ) != -1 ) {
					//if (files.type == 'video/mp4' || files.type == 'application/pdf' || files.type === 'image/png' || files.type === 'image/jpg' || files.type === 'image/jpeg' || files.type == 'application/pdf' || files.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || files.type == 'application/vnd.ms-excel' || files.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || files.type == 'application/msword' || files.type == 'application/x-zip-compressed' || files.type == 'text/plain') {
						this.fileObj = files;
						var currentInput = document.getElementById('quoteFile');
						currentInput.value = '';
						this.$store.dispatch({
							type: 'fncUploadStockAvailibility',
							files: files,
							quoteId: this.globalModalParams.quoteId
						})
					} else {
						var snackDetails = { color: 'error', message: 'Please upload a valid file type', display: true };
						this.$store.commit('setSnack', snackDetails);
					}
				}
			}
		},
		components: {
			DatePicker
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'stockAvailability'
			])
		},
		created() {
			this.$store.dispatch('fncPopulateStock');
      this.allowedFileTypes = String(this.objAuthorize.allowed_file_types).split(',');
      this.maxFileSize = parseInt(this.objAuthorize.max_upload_size);
		},
		mounted() {
			/*if( this.stockAvailability != '' ) {

			}*/
		console.log( this.stockAvailability );
		},
		watch: {
			stockAvailability() {
				this.stockTable = [];
				this.stockTable.push({url: this.stockAvailability});
			}
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
